import request from '../../../shared/request'

export function getProposalTemplates() {
  return request(`/templates/proposal`)
}

export function getContractTemplates() {
  return request(`/templates/contract`)
}

export function getProposalTemplateSections(template_id) {
  return request(`/templates/proposal/${template_id}/section`)
}

export function getProposalTemplateItems(template_id) {
  return request(`/templates/proposal/${template_id}/item`)
}



// WEBPACK FOOTER //
// ./src/redux/api/lead/templates.js